// tslint:disable-next-line:no-reference
/// <reference path="./typings.d.ts" />
export { default as WithCss } from "./components/WithCss";
export { default as WithGlobalCss } from "./components/WithGlobalCss";
export { WidgetConfigurationProvider, } from "./config/WidgetConfigurationProvider";
export { withWidgetConfiguration, } from "./config/withWidgetConfiguration";
export { WidgetConfiguration } from "./config/WidgetConfiguration";
export { initializeWidgetConfiguration, widgetConfiguration, testWidgetConfiguration, } from "./config";
export { SgWidget } from "./SgWidget";
export { h } from "preact";
//# sourceMappingURL=index.js.map